var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.iconClass,on:{"click":_vm.handleClick,"mouseenter":_vm.handleMouseenter,"mouseleave":_vm.handleMouseleave}})}
var staticRenderFns = []

export { render, staticRenderFns }